import { OwnContractMapper } from './OwnContractMapper.js';

class OwnContractRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  register(ownContract) {
    return this.apiClient.post('pro/contracts', OwnContractMapper.registrationPayload(ownContract)).then(response => OwnContractMapper.createOwnContractIdModelFromResponse(response.data));
  }
  deactivate(contractId) {
    return this.apiClient.delete(`pro/contracts/${contractId}`).then(response => {
      return OwnContractMapper.createDeactivateOwnContractModelFromResponse(response.data);
    });
  }
  linkServices(contractId, services) {
    return this.apiClient.put(`pro/contracts/${contractId}/services`, OwnContractMapper.linkServicesPayload(services)).then(response => response.data);
  }
}

export { OwnContractRepository };
//# sourceMappingURL=OwnContractRepository.js.map
